// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"9e68d0b9","279":"31e0d11f","387":"72928dbf","415":"2d7a83b9","544":"2ee4d36c","779":"ddeeb5bd","856":"25110a3a","988":"f9e998e7"}[chunkId] + ".chunk.js";
};